import React, { Component } from 'react';
import { connect } from 'react-redux';
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
import { Translations, convertStringToArrayForOption } from '../../../utils';
import SimpleDropdown from '../../common/SimpleDropdown';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { buildFeatureFlagsPayload, getLoggedInUserId, isSuperAdmin, resolveFeatureFlags } from '../../../featureFlags';
import { FEATURE_FLAGS_TAXONOMY, USER_FEATURE_FLAGS_URL } from '../../../featureFlags/flags';
import FeatureFlagsSection from './FeatureFlagsSection';
import { ROLES } from '../../../constants';
// styles
import './AddUser.css';

const validate = (userName, name, email, role, countryOfUser) => {
  const reg = /^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{1,}))$/;
  return {
    userName: userName.length === 0,
    name: name.length === 0,
    email: email.length === 0 || reg.test(String(email).toLowerCase()) === false,
    role: role.length === 0,
    countryOfUser: Object.keys(countryOfUser).length === 0
  };
}

class AddUser extends Component {
  state = {
    userName: "",
    email: "",
    name: "",
    phone: "",
    glsApprover: null,
    // productManager: null,
    role: "",
    countryOfUser: {},
    touched: {
      userName: false,
      email: false,
      name: false,
      role: false,
      countryOfUser: false
    },
    roleListData: [],
    userCountry: [],
    addUserJson: {},
    featureFlagDefinitions: [],
    featureFlagValues: {},
    initialFeatureFlagValues: {}
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  componentWillMount() {
    aemHostClient("/aemData/formData/json_add-user")
      .then(({ data }) => {
        this.setState({ addUserJson: data.par });
      });

    // Load Taxonomy data for role detail
    taxonomyHostClient("/taxonomies/urn:hsbc:cmb:gdocs:user:taxonomies:roles")
      .then(({ data, status }) => {
        this.setState({
          roleListData: data.responseData.classificationNodes.slice(1)
        })
      })

    taxonomyHostClient("/taxonomies/party/countries")
      .then(({ data }) => {
        this.setState({ userCountry: data.responseData.countryTaxonomy.classificationNodes });
      });

    taxonomyHostClient(FEATURE_FLAGS_TAXONOMY)
      .then(({ data }) => {
        const definitions = (data.responseData.classificationNodes || [])
          .filter(def => def.active === true);
        const values = resolveFeatureFlags(definitions, {});
        this.setState({
          featureFlagDefinitions: definitions,
          featureFlagValues: values,
          initialFeatureFlagValues: values
        });
      })
      .catch(() => { });
  }

  setRole = (e) => {
    let roleValue = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    let texonomiId = e.target.value;
    this.setState({
      role: roleValue,
      texoId: texonomiId
    })
  }

  handleBlur = field => evt => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
    if (event.target.value === ROLES.SALES_MANAGER) {
      this.setState({
        glsApprover: 'false'
      });
    }
  }

  setFeatureFlagValue = (flagId, enabled) => {
    this.setState(prevState => ({
      featureFlagValues: { ...prevState.featureFlagValues, [flagId]: enabled }
    }));
  }

  submitForm = () => {
    let Payload = {
      userName: this.state.userName,
      email: this.state.email,
      name: this.state.name,
      phone: this.state.phone,
      glsApprover: JSON.parse(this.state.glsApprover),
      // productManager: JSON.parse(this.state.productManager),
      role: this.state.role,
      country: this.state.countryOfUser
    }

    const featureFlags = buildFeatureFlagsPayload(
      this.state.initialFeatureFlagValues,
      this.state.featureFlagValues,
      this.state.featureFlagDefinitions,
      this.props.isSuperAdmin,
      this.props.loggedInUserId
    );

    this.props.blockUi();
    eapiClient("/users", {
      method: 'POST',
      data: JSON.stringify(Payload)
    })
      .then(({ data }) => {
        const newUserId = data.responseData && data.responseData.id;
        if (featureFlags.length === 0 || !newUserId) {
          return null;
        }
        return eapiClient(USER_FEATURE_FLAGS_URL.replace(':userId', newUserId), {
          method: 'PUT',
          data: JSON.stringify({ userId: newUserId, featureFlags: featureFlags })
        });
      })
      .then(() => {
        this.props.unBlockUi();
        this.props.history.push('/admin-panel/')
      })
      .catch(() => {
        this.props.unBlockUi();
        this.props.history.push('/admin-panel/')
      });
  }

  submit = () => {
    if (this.state.role !== '' && this.state.role === ROLES.CASE_WORKER) {
      let payload = {
        ...this.state,
        role: {
          name: 'Case Worker',
          value: ROLES.CASE_WORKER
        }
      }
      this.setState({
        ...payload
      }, () => this.submitForm())
    } else if (this.state.role !== '' && this.state.role === ROLES.ADMIN) {
      let payload = {
        ...this.state,
        role: {
          name: 'Admin',
          value: ROLES.ADMIN
        }
      }
      this.setState({
        ...payload
      }, () => this.submitForm())
    }
    else if (this.state.role !== '' && this.state.role === ROLES.SALES_MANAGER) {
      let payload = {
        ...this.state,
        role: {
          name: 'Sales Manager',
          value: ROLES.SALES_MANAGER
        }
      }
      this.setState({
        ...payload
      }, () => this.submitForm())
    }

  }

  setUserCountry = (event) => {
    let _countryOfUser = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    }
    this.setState({ countryOfUser: _countryOfUser });
  }

  render() {
    const errors = validate(this.state.userName, this.state.name, this.state.email, this.state.role, this.state.countryOfUser);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    const displayError = field => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];

      return hasError ? shouldShow : false;
    };

    if (Object.keys(this.state.addUserJson).length > 0) {
      return (
        <div className="add_user_container">
          <div className="form-title">
            <h3>
              {this.translations(this.state.addUserJson.static_text_addUser.addUserHeading)}
            </h3>
          </div>
          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.static_text_addUser.addUserUserName)}
            </label>
            <div className="field-container">
              <input
                className=""
                type="text"
                name="userName"
                onBlur={this.handleBlur('userName')}
                value={this.state.userName}
                onChange={this.handleChange}
              />
              {
                displayError("userName") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addUserJson.static_text_addUser.addUserUserNameMandatoryMessage)}
                  </div>
                ) : ''
              }
            </div>
          </div>
          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.static_text_addUser.addUserName)}
            </label>
            <div className="field-container">
              <input
                className=""
                type="text"
                name="name"
                onBlur={this.handleBlur('name')}
                value={this.state.name}
                onChange={this.handleChange}
              />
              {
                displayError("name") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addUserJson.static_text_addUser.addUserNameMandatoryMessage)}
                  </div>
                ) : ''
              }
            </div>
          </div>

          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.static_text_addUser.addUserEmail)}
            </label>
            <div className="field-container">
              <input
                className=""
                type="text"
                name="email"
                value={this.state.email}
                onBlur={this.handleBlur('email')}
                onChange={this.handleChange}
              />
              {
                displayError("email") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addUserJson.static_text_addUser.addUserEmailMandatoryMessage)}
                  </div>
                ) : ''
              }
            </div>
          </div>
          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.static_text_addUser.addUserPhone)}
            </label>
            <div className="field-container">
              <input
                className=""
                type="text"
                name="phone"
                value={this.state.phone}
                onChange={this.handleChange}
                maxlength={10}
              />
            </div>
          </div>
          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.static_text_addUser.addUserCountry)}
            </label>
            <div className="field-container">
              <SimpleDropdown
                name="userCountry"
                value={this.state.countryOfUser.value}
                defaultValue={this.translations(this.state.addUserJson.dropdownlist_userRole.value)}
                _onChange={this.setUserCountry}
                options={this.state.userCountry}
                _onBlur={this.handleBlur('countryOfUser')}
                optionTextSelector={"name"}
                type="country"
              />
              {
                displayError("countryOfUser") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addUserJson.static_text_addUser.addUserCountryMandatoryMessage)}
                  </div>
                ) : ''
              }
            </div>
          </div>
          <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.dropdownlist_userRole.dropDownLabel)}
            </label>
            <div className="field-container">
              <div className="user-detail--role-type-section">
                <div className="user-detail--role-type-section-arrow">
                  <span aria-hidden="true" className="alignVerLine">|</span>
                  <span className="icon icon-chevron-down-small" style={{ position: 'absolute', top: '4px' }}></span>
                </div>
                <select
                  className="user-detail--role-type-section-drop-down"
                  value={this.state.role !== '' ? this.state.role : this.translations(this.state.addUserJson.dropdownlist_userRole.value)}
                  name="role"
                  onChange={this.handleChange}
                  onBlur={this.handleBlur('role')}
                >
                  <option disabled>
                    {this.translations(this.state.addUserJson.dropdownlist_userRole.value)}
                  </option>
                  {
                    this.state.roleListData.map((item, index) => (<option key={index} value={item.id} > {item.description} </option>))
                  }
                </select>

              </div>
              {
                displayError("role") ? (
                  <div className="input-error-msg-section gdocs-error-align">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addUserJson.dropdownlist_userRole.mandatoryMessage)}
                  </div>
                ) : ''
              }
            </div>
          </div>
          {this.state.role !== ROLES.SALES_MANAGER ? <div className="field_row">
            <label className="label-container">
              {this.translations(this.state.addUserJson.radiobutton_glsApprover.title)}
            </label>
            <div className="field-container">
              <label className="gdocs-mright-30">
                <input
                  type="radio"
                  name="glsApprover"
                  value={true}
                  defaultChecked={this.state.glsApprover === true ? true : false}
                  onChange={this.handleChange}
                />
                {this.translateWord(this.state.addUserJson.radiobutton_glsApprover.options)[0].split('=')[1]}
              </label>
              <label>
                <input
                  type="radio"
                  name="glsApprover"
                  value={false}
                  defaultChecked={this.state.glsApprover === false ? true : false}
                  onChange={this.handleChange}
                />
                {this.translateWord(this.state.addUserJson.radiobutton_glsApprover.options)[1].split('=')[1]}
              </label>
            </div>
          </div> : null}
          <FeatureFlagsSection
            heading="Feature access"
            definitions={this.state.featureFlagDefinitions}
            values={this.state.featureFlagValues}
            onChange={this.setFeatureFlagValue}
            superAdmin={this.props.isSuperAdmin}
            route={this.props.history.location.pathname}
          />
          <div className="gdocs-clear-float"></div>
          <div className="user-detail--submit-section">
            <div className="form-buttons-wrapper">
              <button className="gdocs-btn-submit" onClick={this.submit} disabled={isDisabled}>
                {this.translations(this.state.addUserJson.button_save.text)}
              </button>
            </div>
          </div>

        </div>
      )
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  lang: state.lang,
  loggedInUserId: getLoggedInUserId(state.auth.userDetails),
  isSuperAdmin: isSuperAdmin(state.auth.userDetails)
})

const mapDispatchToProps = dispatch => ({
  blockUi: () => dispatch(blockUi()),
  unBlockUi: () => dispatch(unBlockUi())
})

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);



// WEBPACK FOOTER //
// ./src/components/Admin/UserDetail/AddUser.js